import { ApiResponse } from "../../../../../types";
import { apiClient } from "../../../../../api/client";
import {
  EntregoCheckoutRow,
  EntregoCheckoutListParams,
  ConfirmCheckoutParams,
  DocStartParams,
  SubmitRemessaParams,
} from "../types";

// /gestorEntregoProcessFileViz não é mais chamado daqui: a listagem já traz os
// arquivos processados agregados por data. O endpoint segue publicado no backend.
export const entregoCheckoutService = {
  async getCheckoutList(
    params: EntregoCheckoutListParams
  ): Promise<ApiResponse<EntregoCheckoutRow[]>> {
    return apiClient.post("/gestorCheckoutList", params);
  },

  async confirmCheckout(
    params: ConfirmCheckoutParams
  ): Promise<ApiResponse<void>> {
    return apiClient.post("/gestorConfirmCheckout", params);
  },

  async startDoc(params: DocStartParams): Promise<ApiResponse<void>> {
    return apiClient.post("/gestorDocStart", params);
  },

  async submitRemessa(
    params: SubmitRemessaParams
  ): Promise<ApiResponse<void>> {
    return apiClient.post("/gestorSubmitRemessaDb", params);
  },
};
